import type { LandingTopic } from "./seedTypes";

/** The topics the landing page links to, each an explore page. */
export const LANDING_TOPICS: LandingTopic[] = [
  { category: "mab", subcategory: "con" },
  { category: "mab", subcategory: "soc" },
  { category: "mab", subcategory: "dec" },
  { category: "phv", subcategory: "min" },
  { category: "phv", subcategory: "anc" },
  { category: "phv", subcategory: "met" },
  { category: "sag", subcategory: "his" },
  { category: "sag", subcategory: "cri" },
  { category: "sag", subcategory: "ant" },
  { category: "eag", subcategory: "beh" },
  { category: "eag", subcategory: "ent" },
  { category: "eag", subcategory: "mac" },
  { category: "nsm", subcategory: "ast" },
  { category: "nsm", subcategory: "qua" },
  { category: "nsm", subcategory: "gen" },
  { category: "tae", subcategory: "art" },
  { category: "tae", subcategory: "rob" },
  { category: "tae", subcategory: "bio" },
  { category: "haw", subcategory: "men" },
  { category: "haw", subcategory: "lif" },
  { category: "haw", subcategory: "nut" },
  { category: "aac", subcategory: "sto" },
  { category: "aac", subcategory: "lan" },
  { category: "aac", subcategory: "mus" },
  { category: "awd", subcategory: "hom" },
  { category: "awd", subcategory: "tra" },
  { category: "awd", subcategory: "pro" },
  { category: "whc", subcategory: "anc" },
  { category: "whc", subcategory: "phi" },
  { category: "whc", subcategory: "bio" },
];

/** The article the landing page puts first: "The Infinite Scroll Was Not an Accident". */
export const BOOSTED_ARTICLE = { authorAlias: "nottldr", articleId: "0i9ssvn" };

/** How many popular articles the landing page shows. */
export const LANDING_ARTICLES = 10;
